import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { SERVICES } from "@/data/services";

export default function ServiceRows() {
  const [active, setActive] = useState(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 26, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 200, damping: 26, mass: 0.5 });

  const onMove = (e) => {
    x.set(e.clientX + 24);
    y.set(e.clientY - 120);
  };
  const svc = SERVICES.find((s) => s.slug === active);

  return (
    <div className="relative" onMouseMove={onMove} onMouseLeave={() => setActive(null)} data-testid="home-service-rows">
      {SERVICES.map((s, i) => (
        <FadeUp key={s.n} delay={i * 0.05}>
          <Link
            to="/services"
            data-testid={`home-service-row-${s.n}`}
            onMouseEnter={() => setActive(s.slug)}
            className="group grid grid-cols-[auto_1fr_auto] items-center gap-6 border-t border-white/10 py-8 transition-colors duration-500 last:border-b hover:bg-white/[0.02] lg:gap-12 lg:py-10"
          >
            <span className="font-mono text-sm" style={{ color: s.color }}>{s.n}</span>
            <div>
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-paper transition-transform duration-500 group-hover:translate-x-3 sm:text-3xl lg:text-5xl">
                {s.title}
              </h3>
              <p className="mt-2 flex flex-wrap items-center gap-x-4 text-sm text-zinc-500 transition-colors duration-500 group-hover:text-zinc-400">
                <span className="font-hindi text-base" style={{ color: s.color }}>{s.hindi}</span>
                <span className="max-w-xl">{s.short}</span>
              </p>
            </div>
            <ArrowUpRight className="h-6 w-6 text-zinc-600 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-paper" />
          </Link>
        </FadeUp>
      ))}

      <AnimatePresence>
        {svc && (
          <motion.div
            key={svc.slug}
            data-testid="service-hover-preview"
            className="pointer-events-none fixed left-0 top-0 z-[60] hidden h-[240px] w-[320px] overflow-hidden rounded-2xl border border-white/10 lg:block"
            style={{ x: sx, y: sy }}
            initial={{ opacity: 0, scale: 0.8, rotate: -6 }}
            animate={{ opacity: 1, scale: 1, rotate: -3 }}
            exit={{ opacity: 0, scale: 0.9, rotate: 4 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <img src={svc.img} alt="" className="h-full w-full object-cover grayscale" />
            <div className="absolute inset-0 mix-blend-color" style={{ background: svc.color, opacity: 0.6 }} />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/90 to-transparent p-4">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper">{svc.n} — {svc.title}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
